let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("kW5ll")]).then(() => parcelRequire('8u6tU'));